import React from 'react';
import img404 from '../assets/images/404/img404.svg';

class NotFound extends React.Component {
  render() {
    return (
      <div className="not-found text-center">
        <figure>
          <img src={img404} alt="img-error-404" className="img-fluid" />
        </figure>
        <h1>404</h1>
        <h2><strong>Página não encontrada</strong></h2>
        <p>Se o problema persistir, entre em contato com <strong>support@educat.com</strong> informando o erro  <br /> e continue para à <a href="/"><u><strong>página inicial do site</strong></u></a>.
        </p>
      </div>
    );
  }
}

export default NotFound;
